/** Type used for 'Content-Type' in @see Request.headers. */
export enum HttpContentType {
  applicationJavascript = 'application/javascript',
  applicationJson = 'application/json',
  applicationXWwwFormUrlencoded = 'application/x-www-form-urlencoded',
  applicationXml = 'application/xml',
  applicationZip = 'application/zip',
  imageGif = 'image/gif',
  imageJpeg = 'image/jpeg',
  imagePng = 'image/png',
  multipartFormData = 'multipart/form-data',
  textCss = 'text/css',
  textCsv = 'text/csv',
  textHtml = 'text/html',
  textPlain = 'text/plain',
  textXml = 'text/xml'
}
